var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39 39",
    style: {
      enableBackground: "new 0 0 39 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-back",
    d: "M18.3,7.6c0.8,0.8,0.9,2.2,0,3.1L8.2,20.8h28.6c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2 l0,0H8.2l10.1,10.1c0.8,0.9,0.8,2.2,0,3.1c-0.8,0.8-2.2,0.8-3.1,0L1.5,24.5l0,0c-0.2-0.2-0.3-0.4-0.5-0.7C1,23.6,0.9,23.3,0.9,23 c0-0.6,0.2-1.1,0.6-1.5L15.3,7.7C16.1,6.8,17.4,6.8,18.3,7.6C18.3,7.6,18.3,7.6,18.3,7.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBack);
export default __webpack_public_path__ + "static/media/icon-arrow-back.5b3beae934cb141daa030f265c02dd9f.svg";
export { ForwardRef as ReactComponent };